import type {TabsProps} from 'antd';
import {Tabs, theme} from 'antd';
import {Wrapper} from 'Components';
import AdminSRDashboard from 'Pages/AdminSRDashboard';
import SearchMember from 'Pages/SearchMember';
import TransactionsDashboard from 'Pages/TransactionsDashboard';
import React from 'react';
import styles from './styles';
import './styles.css';

const SearchDashboard = () => {
  const {token} = theme.useToken();

  const items: TabsProps['items'] = [
    {
      key: 'membership',
      label: 'Membership',
      children: <SearchMember />,
    },
    // 'Service Request' (SRSearch) is intentionally omitted here — it was hidden
    // (display: none) on the original MUI tab strip and unreachable from the UI.
    {
      key: 'srDashboard',
      label: 'SR Dashboard',
      children: <AdminSRDashboard />,
    },
    {
      key: 'transactions',
      label: 'Transactions',
      children: <TransactionsDashboard />,
    },
  ];

  const tabThemeVars = {
    '--tab-accent': token.colorPrimary,
    '--tab-text-secondary': token.colorTextSecondary,
  } as React.CSSProperties;

  return (
    <Wrapper>
      <div style={styles.container}>
        <div style={{...styles.tabsContainer, ...tabThemeVars}}>
          <Tabs
            centered
            items={items}
            style={styles.tabs}
            className="search-dashboard-tabs"
            tabBarGutter={64}
            // matches the original's behavior of fully unmounting an inactive
            // tab's content on every switch, rather than antd's default of
            // keeping it mounted-but-hidden after the first visit.
            destroyOnHidden
          />
        </div>
      </div>
    </Wrapper>
  );
};

export default SearchDashboard;
